import { render, staticRenderFns } from "./Partneransicht.vue?vue&type=template&id=37a3d10b&scoped=true&"
import script from "./Partneransicht.vue?vue&type=script&lang=js&"
export * from "./Partneransicht.vue?vue&type=script&lang=js&"
import style0 from "./Partneransicht.vue?vue&type=style&index=0&id=37a3d10b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a3d10b",
  null
  
)

export default component.exports